import ArtistListPage from './ArtistListPage';

export default ArtistListPage;
